import { AllClusterHandler } from 'components/MapComponent/MapUtils/ClusterPoints/AllClusterHandler';
import React from 'react';
import { ClusterPoints } from 'components/MapComponent/MapUtils/ClusterPoints';
import { DrawWMTS } from 'components/MapComponent/MapUtils/DrawWMTS';
import { MeasurementMap } from './MeasurementMap';
import { DrawWKT } from 'components/MapComponent/MapUtils/DrawWKT';
import { LayerClusters } from './LayerClusters';
import { LayerClustersHandler } from './LayerClusters/LayerClustersHandler';

export const MapUtils: React.FC = (): JSX.Element => {
  return (
    <>
      <MeasurementMap />
      <DrawWKT />
      <DrawWMTS />
      <ClusterPoints /> {/*  for search tab */}
      <AllClusterHandler />
      <LayerClusters /> {/*  for layers */}
      <LayerClustersHandler />
    </>
  );
};
